<template>
  <div class="card card border-primary mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      {{ $t('a-softwaresImport:importSoftwares') | capitalize }}
    </div>

    <div class="card-body">
      <dropzone v-if="status==='READY'"
                id="importSoftwares"
                :url="url"
                accepted-files=".tar.gz, .tgz, .tar, .ipk"
                icon="icon-file"
                :start-upload.sync="startUpload"
                @dropzone-file-added="startUpload=true"
                @dropzone-file-removed="startUpload=false"
                @dropzone-success="onUploadSuccess"
                @dropzone-error="onUploadError"
      />

      <div v-if="status!=='READY'" class="drop-container">
        <div>
          <div v-if="status==='OK'" class="d-flex justify-content-between">
            {{ $t('a-softwaresImport:success', {software: file.name}) | capitalize }}
            <span class="icon-check no-pointer text-success" />
          </div>
          <div v-if="status==='KO'" class="d-flex justify-content-between">
            {{ $t('a-softwaresImport:error', {software: file.name}) | capitalize }}
            <span class="icon-remove no-pointer text-danger" />
          </div>

          <div class="dz-preview">
            <div class="dz-progress"><span style="width:100%" class="dz-upload" /></div>

            <div v-if="error && error.length>0" class="dropzone-error-container font-italic">
              <ul>
                <li v-if="typeof error==='string'" class="ml-2 text-danger">
                  {{ error }}
                </li>
                <li v-for="(err, indexError) in error" v-else :key="indexError">
                  {{ err.main }}
                  <ul v-if="err.details && err.details.length>0" class="ml-2">
                    <li v-for="(detail, indexDetail) in err.details" :key="indexDetail" :class="[err.type==='warning' ? 'text-warning' : 'text-danger']">{{ detail }}</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="row">
              <div class="col-md-12">
                <a id="uploadAnotherFileButton" class="dz-remove" @click.prevent="reset">
                  {{ $t('a-softwaresImport:uploadAnotherFile') | capitalize }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      startUpload: false,
      status: 'READY',
      file: null,
      error: ''
    }
  },

  computed: {
    url () {
      return this.$utils.getLinkHref(this.$store.getters.application, 'softwares')
    }
  },

  methods: {
    reset () {
      this.status = 'READY'
      this.file = null
      this.error = ''
    },

    onUploadSuccess (file) {
      this.status = 'OK'

      this.file = file

      this.$emit('upload-success')
    },

    onUploadError (file, error) {
      this.status = 'KO'

      this.file = file

      this.error = this.$utils.processErrors(error)

      this.$emit('upload-error')
    }
  }
}
</script>
